import { Scatter } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import {
  Chart as ChartJS,
  Legend,
  LinearScale,
  PointElement,
  Tooltip,
} from 'chart.js';
import Button from 'components/Button/Button';
import ContentLoader from 'components/ContentLoader/ContentLoader';
import Select from 'components/Select/Select';
import { BUTTON_VARIANT, DELETE_MODAL_TITLES } from 'constants/interfaces';
import DeleteModal from 'pages/CompanyAdminPages/ValueChainMap/components/DeleteModal/DeleteModal';

import useMAIroChart from './hooks/useMAIroChart';

import type IOption from 'components/MappingModal/interfaces/IOption';
import type IMAIroScoring from './interfaces/IMAIroScoring';

import styles from './scss/MAIroScoring.module.scss';

ChartJS.register(LinearScale, PointElement, Tooltip, Legend);

function MAIroScoringView({
  handleGoBack,
  items,
  loading,
  vcOptions,
  valueSelector,
  setValueSelector,
  handleOpenFinishModal,
  handleCancel,
  isFinishModalOpen,
  onCloseFinishModal,
  onFinishConfirm,
}: Readonly<IMAIroScoring>) {
  const { t } = useTranslation();
  const { chartData, chartOptions, backgroundPlugin } = useMAIroChart({ items });

  return (
    <div className={styles.root}>
      <div className={styles.rootContainer}>
        <div className={styles.wrapper}>
          <div className={styles.header}>
            <span className={styles.titleHint}>{t('materialityAssessment.titleIROScoring')}</span>
            <Select
              placeholder={t('common.selectVC')}
              options={vcOptions}
              value={vcOptions.find((option) => option.value === valueSelector) || null}
              onChange={(selectedOption) => setValueSelector((selectedOption as IOption)?.value || '')}
              menuPosition="absolute"
              className={styles.select}
              maxMenuHeight={200}
            />
          </div>
          <div className={styles.contentWrapper}>
            {loading ? (<ContentLoader title={t('materialityAssessment.loadingIROScore')} />) : null}
            {!loading && (
              <div className={styles.chartContainer}>
                <div className={styles.chart}>
                  <Scatter
                    data={chartData}
                    options={chartOptions}
                    plugins={[backgroundPlugin]}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={handleCancel}
          />
          <div className={styles.rightButtons}>
            <Button
              title={t('common.prev')}
              onClick={handleGoBack}
              variant={BUTTON_VARIANT.cancel}
              className={styles.prevButton}
            />
            <Button
              title={t('common.sendToReview')}
              onClick={handleOpenFinishModal}
              className={styles.buttonReview}
            />
          </div>
        </div>
      </div>
      <DeleteModal
        open={isFinishModalOpen}
        onReject={onCloseFinishModal}
        isLoading={false}
        name=""
        title={DELETE_MODAL_TITLES.FINISH_MA}
        confirmTitle={t('common.confirm')}
        hint="finishMAHint"
        onConfirm={onFinishConfirm}
      />
    </div>
  );
}

export default MAIroScoringView;
